<button [matMenuTriggerFor]="groupByMenu" aria-label="Open interactions grouping menu" mat-button>
	<mat-icon>{{menuIcon()}}</mat-icon>
	<span>{{menuLabel()}}</span>
</button>

<mat-menu #groupByMenu="matMenu" class="custom-mat-panel">
	@for (option of options(); track option.value) {
		@if (groupBy() !== option.value) {
			<button (click)="groupingSelected.emit(option.value)" mat-menu-item>
				<mat-icon>{{option.icon}}</mat-icon>
				<span>{{option.label}}</span>
			</button>
		}
	}
</mat-menu>
